import { useTranslation } from "react-i18next";

import {
  Artifact,
  ArtifactProjectType,
  LutronDesignerMessageType,
} from "../../models";
import ArtifactKebabMenu from "../ArtifactKebabMenu/ArtifactKebabMenu";
import { useToolContext } from "../ToolContext/ToolContext";

import { ActionButton, TableCell } from "./TableStyle";

type Props = {
  onClick: () => void;
  placeId: string;
  artifact: Artifact;
  designCount: number;
  setExpandedRowId: (id: string) => void;
  expandedRowId: string;
};

const OpenArtifactCell = ({
  onClick,
  placeId,
  artifact,
  designCount,
  setExpandedRowId,
  expandedRowId,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const context = useToolContext();

  return (
    <TableCell>
      {designCount > 1 && expandedRowId !== placeId ? (
        <ActionButton
          data-testid={`show-more[${placeId}]`}
          onClick={() => setExpandedRowId(placeId)}
        >
          {t("table.actions.show_all_designs")}
        </ActionButton>
      ) : (
        expandedRowId === placeId && (
          <ActionButton
            data-testid={`show-less[${placeId}]`}
            onClick={() => setExpandedRowId("")}
          >
            {t("table.actions.hide_all_designs")}
          </ActionButton>
        )
      )}

      {designCount === 1 && (
        <ActionButton
          data-testid={`place-open-btn[${placeId}]`}
          onClick={onClick}
        >
          {t("table.actions.download_artifact")}
        </ActionButton>
      )}
      {designCount === 1 &&
        (context.capabilities?.includes(
          LutronDesignerMessageType.OpenVersionRequest,
        ) ||
          (artifact.artifactProjectType === ArtifactProjectType.LDPlus &&
            context.capabilities?.includes(
              LutronDesignerMessageType.MigrateToAthenaRequest,
            ))) && <ArtifactKebabMenu artifact={artifact} />}
    </TableCell>
  );
};

export default OpenArtifactCell;
